import React from 'react';
import { Tooltip, ClickAwayListener } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { HelpOutline } from '@material-ui/icons';
import { withStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  tooltip: {
    marginBottom: `-${theme.spacing(0.5)}px`
  }
}));

const CustomTooltip = withStyles({
  tooltip: {
    border: '1px solid #C2CED3',
    background: 'white',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#434343',
    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.2)",
    borderRadius: "5px",
    paddingTop: '1rem',
    paddingBottom: '1rem',
    paddingLeft: '0.5rem',
  },
})(Tooltip);

const ClickableTooltip = ({tooltip, placement}) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const handleTooltipClose = () => setOpen(false);
  const handleTooltipOpen = () => setOpen(true);

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <CustomTooltip
        PopperProps={{ disablePortal: true, }}
        open={open}
        onClose={handleTooltipClose}
        className={classes.tooltip}
        title={tooltip}
        placement={placement}
        disableFocusListener
      >
        <HelpOutline onMouseOver={handleTooltipOpen} onClick={handleTooltipOpen} fontSize="small" />
      </CustomTooltip>
    </ClickAwayListener>
  );
};

export default ClickableTooltip;
